module.exports = __webpack_public_path__ + "img/icon_nav_tests.87692b9.svg";